/* import __COLOCATED_TEMPLATE__ from './pick-conversation-data-attribute-value.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class PickConversationDataAttributeValue extends Component {
  @tracked action = this.args.action;
  @tracked actionEditorContext = this.args.actionEditorContext;
  @service attributeService;
  @service intl;

  get conversationDataAttribute() {
    return this.attributeService.conversationCustomAttributes.find(
      (attribute) => attribute.identifier === this.identifier,
    );
  }

  get conversationDataAttributeType() {
    return this.conversationDataAttribute?.type ?? null;
  }

  get identifier() {
    return this.action.get('actionData.attribute_identifier');
  }

  get label() {
    let name = this.conversationDataAttribute?.name;
    if (!name) {
      return this.intl.t('inbox.attribute-list-item.unknown');
    }
    return this.intl.t('settings.inbox-rules.index.actions.conversation-data-attribute.label', {
      name,
    });
  }

  get details() {
    if (this.formatValue) {
      return this.intl.t('settings.inbox-rules.index.actions.conversation-data-attribute.details', {
        value: this.formatValue,
      });
    }
    return '';
  }

  get value() {
    return this.action.get('actionData.value');
  }

  get overlayComponent() {
    return 'rules/pick-conversation-data-attribute-value-overlay';
  }

  get overlayComponentHash() {
    return {
      onUpdate: this.updateValue,
      selectedValue: this.value,
      conversationDataAttribute: this.conversationDataAttribute,
    };
  }

  get formatValue() {
    let attr = this.conversationDataAttribute;
    if (!attr) {
      return this.value ?? '';
    }
    switch (attr.type) {
      case 'conversation_attribute_list':
        return attr.options.find((option) => option.identifier === this.value)?.value ?? this.value;
      case 'boolean':
        return this.value ? 'True' : 'False';
      default:
        return this.value;
    }
  }

  @action
  updateValue(value) {
    let normalizedValue = this.normalizeValue(value);
    let currentActionData = this.action.get('actionData') || {};
    this.action.set('actionData', {
      ...currentActionData,
      value: normalizedValue,
    });

    let onChange = this.args.onChange;
    if (onChange) {
      onChange();
    }
  }

  normalizeValue(value) {
    let type = this.conversationDataAttribute?.type;
    if (type === 'integer' || type === 'decimal') {
      let casted = Number(value);
      if (value === '' || isNaN(casted)) {
        value = null;
      } else {
        value = type === 'integer' ? Math.round(casted) : casted;
      }
    }
    if (type === 'string') {
      value = value.trim();
      if (value === '') {
        value = null;
      }
    }
    return value;
  }
}
